/**
 * Shared WhatsApp / Signal click-to-chat helpers for entry and reservation cards.
 * Prefill copy is always English (not i18n).
 */

export function isMobileMessagingClient() {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
}

export function countryDisplayName(countries, countryCode) {
    if (!countryCode) return "";
    const country = (countries || []).find((entry) => entry.code === countryCode);
    return country?.name || countryCode;
}

/**
 * Open WhatsApp chat; optionally prefill the compose box (official ?text= / &text=).
 * @param {string} phone
 * @param {string} [prefillMessage]
 */
export function openWhatsAppChat(phone, prefillMessage = "") {
    const cleaned = String(phone || "").replace(/\D/g, "");
    if (!cleaned) return;
    const encodedText = prefillMessage ? encodeURIComponent(prefillMessage) : "";
    const link = isMobileMessagingClient()
        ? `https://wa.me/${cleaned}${encodedText ? `?text=${encodedText}` : ""}`
        : `https://web.whatsapp.com/send?phone=${cleaned}${
              encodedText ? `&text=${encodedText}` : ""
          }`;
    window.open(link, "_blank");
}

export function openWhatsAppDownloadPage() {
    window.open("https://www.whatsapp.com/download", "_blank");
}

export function openSignalChat(phone) {
    const cleaned = String(phone || "").replace(/[^+\d]/g, "");
    if (!cleaned) return;
    window.open(`https://signal.me/#p/${cleaned}`, "_blank");
}

export function openSignalDownloadPage() {
    window.open("https://signal.org/download/", "_blank");
}

function entryKindLabel(formType) {
    return formType === "ware" ? "ware" : "truck";
}

/**
 * Listing-card message (entry date windows). Always English; trailing space preserved.
 */
export function buildEntryWhatsAppContactMessage(payload) {
    const kind = entryKindLabel(payload.formType);
    const id = payload.id || "";
    const fromCountry = payload.fromCountry || "";
    const fromCity = payload.fromCity || "";
    const fromDateStart = payload.fromDateStart || "";
    const fromDateEnd = payload.fromDateEnd || "";
    const toCountry = payload.toCountry || "";
    const toCity = payload.toCity || "";
    const toDateStart = payload.toDateStart || "";
    const toDateEnd = payload.toDateEnd || "";
    return (
        `Hello, I am contacting you regarding the MekonSM ${kind} entry ID ${id} ` +
        `from ${fromCountry}, ${fromCity} (${fromDateStart} - ${fromDateEnd}) ` +
        `to ${toCountry}, ${toCity} (${toDateStart} - ${toDateEnd}). `
    );
}

/**
 * Reservation-card message (chosen load/unload date + time). Always English; trailing space preserved.
 */
export function buildReservationWhatsAppContactMessage(payload) {
    const kind = entryKindLabel(payload.formType);
    const id = payload.id || "";
    const fromCountry = payload.fromCountry || "";
    const fromCity = payload.fromCity || "";
    const fromWhen = payload.fromWhen || "";
    const toCountry = payload.toCountry || "";
    const toCity = payload.toCity || "";
    const toWhen = payload.toWhen || "";
    return (
        `Hello, I am contacting you regarding the MekonSM ${kind} reservation ID ${id} ` +
        `from ${fromCountry}, ${fromCity} (${fromWhen}) ` +
        `to ${toCountry}, ${toCity} (${toWhen}). `
    );
}

export function formatReservationContactWhen(scheduledDate, scheduledTime) {
    if (scheduledDate && scheduledTime) return `${scheduledDate}, ${scheduledTime}`;
    return scheduledDate || scheduledTime || "";
}
